import { FunctionComponent } from "react";
import EntityDashboard from "../components/entity_dashboard";

const DeptDashboardScreen: FunctionComponent = () => (
  <EntityDashboard variant="dept" />
);

export default DeptDashboardScreen;
